import SignUpComp from '../../components/signup/SignUpComp.jsx'

export const SignupPage = () => {
	return <SignUpComp />
}
